import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DeleteDepartmentComponent } from './delete-department/delete-department.component';
import { AddEditDepartmentComponent } from './add-edit-department/add-edit-department.component';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-products-departments',
    templateUrl: './products-departments.component.html',
    styleUrls: ['./products-departments.component.scss'],
    standalone: false
})
export class ProductsDepartmentsComponent implements OnInit {
  showSearch: boolean;
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  currentPage = 0;
  totalSize = 0;
  deleteDialog = false;
  pageSize = 10;
  pageNumber = 1;
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null
  };

  departmentsList = new Array<any>();
  searchValue = "";

  constructor(private router: Router, public dialog: MatDialog,
              public utils: UtilsService,
              private route: ActivatedRoute,
              private dataService: DataService,
              private exportService: ExportService
              ) {
    this.showSearch = false;
    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
      }
      this.getDepartments();
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  ngOnInit(): void {
    this.utils.setTitle('Product Departments');
    this.utils.screenTitle.emit({firstTitle: 'Product Departments', firstRoute: '/products-departments'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }
  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
    this.router.navigate(['/products-departments'], { queryParams: this.queryParams });
  }
  handleSearchClick() {
    if (this.showSearch && this.departmentsList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }
  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
      this.router.navigate(['/products-departments'], { queryParams: this.queryParams });
    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue
    };
    this.router.navigate(['/products-departments'], { queryParams: this.queryParams });
  }

  addDepartment() {
    const dialogRef = this.dialog.open(AddEditDepartmentComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Add',
      }
    });
    dialogRef.afterClosed().subscribe((newDepartment) => {
      if (newDepartment) {
        this.departmentsList.unshift(newDepartment);
        this.totalSize = this.totalSize + 1;
        if (this.departmentsList.length <= this.pageSize) {
        } else {
          this.departmentsList.splice(this.departmentsList.length - 1, 1);
        }
      }
    });
  }

  editDepartment(id: any, name: any) {
    const dialogRef = this.dialog.open(AddEditDepartmentComponent, {
      disableClose: true,
      width: '400px',
      data: {
        type: 'Edit',
        id,
        name
      }
    });
    dialogRef.afterClosed().subscribe((editedDepartment) => {
      if (editedDepartment && editedDepartment.id) {
        this.departmentsList.forEach(department => {
          if (department.id === editedDepartment.id) {
            department.name = editedDepartment.name;
          }
        });
      }
    });
    if ( this.deleteDialog ) {
      dialogRef.close();
      this.deleteDialog = false;
    }
  }

  deleteDepartment(id: any) {
    const dialogRef = this.dialog.open(DeleteDepartmentComponent, {
      disableClose: true,
      data: {
        id,
      }
    });
    this.deleteDialog = true;
    dialogRef.afterClosed().subscribe((status) => {
      if (status === 'delete') {
        this.departmentsList.forEach( (department, index) => {
          if (department.id === id) {
            this.departmentsList.splice(index, 1);
            if (this.departmentsList.length === 0 && this.pageNumber > 1){
              this.pageNumber = this.pageNumber - 1;
              this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
              this.router.navigate(['/products-departments'], { queryParams: this.queryParams });
            } else {
              this.getDepartments();
            }
          }
        });
      }
    });
  }

  getDepartments() {
    this.dataService.get('department/RetrieveAllDepartments?pageNumber=' + this.pageNumber +
    '&pageSize=' + this.pageSize +
    '&searchKeyword=' + this.searchValue).then((data: any) => {
      if (data.statusCode === 200) {
        this.departmentsList = [];
        const departmentsData = data.data.records;
        this.totalSize = data.data.count;
        departmentsData.forEach((manufacturerData: any) => {
          this.departmentsList.push(manufacturerData);
        });
        if (departmentsData.length === 0 && this.totalSize > 0) {
          this.pageNumber = 1;
          this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
          this.router.navigate(['/products-departments'], { queryParams: this.queryParams });
        }
      }
    });
  }

   exportDepartments(fileTypeId: number) {
    this.exportService.exportFile('department/ExportAllDepartments', fileTypeId, this.searchValue, 'departments');
  }

}
